import React, { useEffect, useState } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import Select from "react-select";
import SalesDeveloperService from "services/Admin/SalesDeveloperService";
import DeveloperService from "services/Admin/DeveloperService";

const FilterForm = ({ showFilters, setDeveloperId, developerId, setShowFilters }) => {
    const developerService = new DeveloperService()
    const [developer, setDeveloper] = useState([])
    const [options, setOptions] = useState([])
    useEffect(() => {
        if (developerId ?.length) {
            setDeveloper([...developerId])
        } else {
            setDeveloper(null)
        }
    }, [])

    useEffect(() => {
        developerService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {id: item.id, value: item.id, label: item.name.en , ...item.name}
            })
            setOptions(newOptions)
        })
    }, [])

    const handleValidSubmit = () => {
        setDeveloperId(developer)
        setShowFilters(false)
        setShowFilters(!showFilters)
    }
    return (
        <Modal isOpen={showFilters} toggle={() => setShowFilters(!showFilters)}
            className="rightModalSide scrollbar-container mt-0" >
            <ModalHeader toggle={() => setShowFilters(!showFilters)}>
                Developer Filters
            </ModalHeader>
            <ModalBody>
                <Col md={12}>
                    <label>Developer</label>
                    <Select
                        placeholder={"Select"}
                        options={options}
                        onChange={(data) => {
                            setDeveloper(data)
                        }}
                        value={developer}
                        isMulti={true}
                    />
                </Col>
            </ModalBody>
            <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                <button
                    type='button'
                    className='btn btn-light w-120'
                    onClick={() => {
                        setDeveloperId(null)
                        setDeveloper(null)
                    }}>
                    Reset Filter
                       </button>
                <button type='button'
                    onClick={() => handleValidSubmit()}
                    className='btn btn-success  w-120'>
                    Apply Filter
                    </button>
            </ModalFooter>
        </Modal>
    )
}

export default FilterForm

